import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import LoginForm from './sections/LoginForm';
import SignUpForm from './sections/SignUpForm';

const AuthCard = ({ defaultTab = 'login' }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const referredAgent = queryParams.get('agent');
  const tabQuery = queryParams.get('tab');

  const [activeTab, setActiveTab] = useState(
    referredAgent || tabQuery === 'register' ? 'register' : defaultTab
  );

  useEffect(() => {
    if (referredAgent || tabQuery === 'register') {
      setActiveTab('register');
    } else if (tabQuery === 'login') {
      setActiveTab('login');
    }
  }, [referredAgent, tabQuery]);

  return (
    <div className="w-full max-w-md bg-white shadow-2xl rounded-3xl p-5 sm:p-6 animate-in fade-in slide-in-from-right duration-700 delay-100 flex flex-col">
      {/* Tab Switcher */}
      <div className="flex border-b border-gray-200 mb-4 sm:mb-5 shrink-0">
        <button
          type="button"
          onClick={() => setActiveTab('login')}
          className={`flex-1 py-2 text-center font-bold text-sm sm:text-base transition-colors cursor-pointer ${
            activeTab === 'login'
              ? 'text-[#067978] border-b-2 border-[#067978]'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          Login
        </button>
        <button
          type="button"
          onClick={() => setActiveTab('register')}
          className={`flex-1 py-2 text-center font-bold text-sm sm:text-base transition-colors cursor-pointer ${
            activeTab === 'register'
              ? 'text-[#067978] border-b-2 border-[#067978]'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          Register
        </button>
      </div>

      {/* Render Active Form */}
      {activeTab === 'login' ? (
        <LoginForm onSwitchToRegister={() => setActiveTab('register')} />
      ) : (
        <SignUpForm
          onSwitchToLogin={() => setActiveTab('login')}
          referredAgent={referredAgent}
        />
      )}
    </div>
  );
};

export default AuthCard;
